export default {
    "Erp.Customer.Manage": {
        sortOrder: 100,
        caption: '客户管理',
        permissionGroupId: "Erp.Customer.Manage",
        path: '/erp/customer/list',
        icon: 'fx-font fx-customers'
    },
    "Erp.Product.Manage": {
        sortOrder: 110,
        caption: '产品管理',
        permissionGroupId: "Erp.Product.Manage",
        path: '/erp/product/list',
        icon: 'fx-font fx-product-manage'
    },
    "Erp.Order.Manage": {
        sortOrder: 120,
        caption: '订单管理',
        permissionGroupId: "Erp.Order.Manage",
        path: '/erp/order/list',
        icon: 'fx-font fx-orders'
    },
    "Erp.Refund.Manage": {
        sortOrder: 120,
        caption: '售后管理',
        permissionGroupId: "Erp.AfterSale.Manage",
        path: '/erp/aftersale/list',
        icon: 'fx-font fx-order'
    },
    "Erp.Stat.Manage": {
        sortOrder: 120,
        caption: '报表统计',
        path: '/erp/stats/manage',
        icon: 'fx-font fx-baobiao',
        children: {
            "Customer.Statement":
            {
                sortOrder: 1000,
                caption: '对账单管理',
                permissionGroupId: "Erp.CustomerBill.Manage",
                path: '/erp/statement/customerbill',
                icon: 'fx-font fx-enquiry',
            },
            "Biz.Statement":
            {
                sortOrder: 1001,
                caption: '业务账单统计',
                permissionGroupId: "Erp.BizBillStat.Manage",
                path: '/erp/statement/bizbill',
                icon: 'fx-font fx-baobiao',
            }
        }
    }



};



// WEBPACK FOOTER //
// ./src/modules/erp/menu.js